module.exports = __webpack_public_path__ + "static/think-aloud-ab67d628ff0c82f876d3136698dd5b0c.png";